import { Box, Flex, Grid, Text, useTheme } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

import { useAppNav } from '@/hooks/useAppNav.hook';
import { useSettings } from '@/hooks/useSettings';

export const MobileNavigation = () => {
  const theme = useTheme();
  const { mobileNav } = useAppNav();
  const { isDesktop } = useSettings();

  return !isDesktop ? (
    <Grid
      bgColor={theme.colors.OlybetGrey07}
      color='white'
      gap='10px'
      gridTemplateColumns={`repeat(${mobileNav.length}, 1fr)`}
      maxW={`${mobileNav.length * 100}px`}
      mx='auto'
    >
      {mobileNav.map(({ Icon, ...item }) => (
        <Box
          as={NavLink}
          color={item?.selected ? theme.colors.OlybetPrimaryRed : 'white'}
          {...item?.linkData}
          key={item.linkData.to as string}
        >
          <Flex
            align='center'
            direction='column'
            justify='center'
            padding='15px 0'
          >
            {!!Icon && (
              <Icon
                {...{
                  fill: item?.selected
                    ? theme.colors.OlybetPrimaryRed
                    : 'white',
                }}
              />
            )}
            <Text fontSize='12px' mt='5px'>
              {item?.label}
            </Text>
          </Flex>
        </Box>
      ))}
    </Grid>
  ) : null;
};
